export const MENU_DRAWER_WIDTH = 285;
export const APP_BAR_HEIGHT = 64;
export const FOOTER_HEIGHT = 68;
